export default __webpack_public_path__ + "static/media/btn_appstore.f8d8bfc2.png";